import { useEffect } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    const getLabel = () => {
        switch (type) {
            case 'success':
                return 'Success';
            case 'error':
                return 'Error';
            case 'warning':
                return 'Warning';
            case 'info':
                return 'Notice';
            default:
                return 'Success';
        }
    };

    return (
        <div className={`toast toast-${type}`}>
            <div className="toast-body">
                <div className="toast-label">{getLabel()}</div>
                <div className="toast-message">{message}</div>
            </div>
            <button className="toast-close" onClick={onClose}>Dismiss</button>
        </div>
    );
};

export default Toast;
